import React from 'react'
import './Footer.css'
export const Footer = () => {
  return (
    <div>
        <div className='footer-container'>
            <div className='footer-container-div'>
                <div className='footer-container-div1'>
                    <div className='footer-container-div1-container'>
                            <div className='footer-container-div1-container-div1'>
                                <div>
                                <img style={{width:"30%"}} src="https://www.shine.com/next/static/images/shine-logo.png" alt="" />
                                    <h2> Great career starts here!</h2>
                                </div>
                            </div>
                            <div className='footer-container-div1-container-div2'>
                                    <h2>Download Shine App</h2>
                                <div>
                                    <div className='footer-container-div1-container-div2-icon'>
                                        <img style={{width:"70%",marginTop:"3px"}} src="https://i1.wp.com/9to5google.com/wp-content/uploads/sites/4/2022/07/current-google-play-icon.jpg?ssl=1" alt="" />
                                    </div>
                                    <div className='footer-container-div1-container-div2-icon'>
                                        <img style={{width:"70%",marginTop:"3px",marginLeft:"-8px"}} src="https://cdn-icons-png.flaticon.com/128/179/179309.png" alt="" />
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div className='footer-container-div2'>
                    <h1 style={{fontSize:"13px",fontWeight:"bold    "}}>JOB SEEKERS</h1>
                    <h2>Register / Login</h2>
                    <h2>Browse Jobs</h2>
                    <h2>Create Free Job Alert</h2>
                    <h2>Job Assistance Services</h2>
                    <h2>Courses</h2>
                </div>
                <div className='footer-container-div3'>
                <h1 style={{fontSize:"13px",fontWeight:"bold    "}}>EMPLOYERS</h1>
                    <h2>Recruiter India</h2>
                    <h2>Post Job</h2>
                   
                </div>
                <div className='footer-container-div4'>
                <h1 style={{fontSize:"13px",fontWeight:"bold    "}}>PARTNER SITES</h1>
                    <h2>English Mate</h2>
                    <h2>Study Mate</h2>
                    <h2>Hindustantimes.com</h2>
                    <h2>Livemint.com</h2>
                    <h2>Livehindustan.com</h2>
                    <h2>OTTplay.com</h2>
                </div>
                <div className='footer-container-div5'>
                <h1 style={{fontSize:"13px",fontWeight:"bold    "}}>CONTACT US</h1>
                    <h2>080-1006 2222</h2>
                    <h2>contactus@shine.com</h2>
                    <div className='footer-container-div5-div'>
                            <div>
                                <img style={{width:"80%"}} src="https://cdn-icons-png.flaticon.com/128/3536/3536505.png" alt="" />
                            </div>
                            <div>
                            <img style={{width:"80%"}} src="https://cdn-icons-png.flaticon.com/128/733/733579.png" alt="" />
                            </div>
                            <div>
                            <img style={{width:"80%"}} src="https://cdn-icons-png.flaticon.com/128/174/174848.png" alt="" />
                            </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className='footer-bottom'>
                <div className='footer-bottom-div1'>
                    <div>

                <h2>
                    Feedback |
                     {/* FAQs | About Us | Contact Us | Privacy Policy | Cookie Policy | Fraud Alert | Business News | English News | Terms & Conditions | Disclaimer | Report a Job Posting */}
                    </h2>
                    <h2>FAQs |</h2>
                    <h2>About Us |</h2>
                    <h2>Contact Us |</h2>
                    <h2>Privacy Policy | </h2>
                    <h2>Cookie Policy |</h2>
                    <h2>Fraud Alert |</h2>
                    <h2>Business News |</h2>
                    <h2>English News |</h2>
                    <h2>Terms & Conditions |</h2>
                    <h2>Disclaimer |</h2>
                    <h2>Report a Job Posting</h2>
                    </div>
                </div>
                <div className='footer-bottom-div2'>
                    <div>
                        <h2>© 2022 HT Media Limited</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
